export const categories = [
  { slug: 'shaonian', name: '少年漫画', icon: 'ri-sword-line' },
  { slug: 'lianai', name: '恋爱漫画', icon: 'ri-heart-line' },
  { slug: 'rexue', name: '热血漫画', icon: 'ri-fire-line' },
  { slug: 'gaoxiao', name: '搞笑漫画', icon: 'ri-emotion-laugh-line' },
  { slug: 'xuanhuan', name: '玄幻漫画', icon: 'ri-magic-line' },
  { slug: 'xuanyi', name: '悬疑漫画', icon: 'ri-search-eye-line' },
  { slug: 'kehuan', name: '科幻漫画', icon: 'ri-rocket-line' },
  { slug: 'dongzuo', name: '动作漫画', icon: 'ri-run-line' },
];

export const comics = [
  {
    id: 1,
    slug: 'mitao-shaonian',
    title: '蜜桃少年',
    author: '桃子工作室',
    category: 'shaonian',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20manhwa%20style%20illustration%20of%20a%20handsome%20young%20boy%20with%20peach%20blossom%20background%2C%20soft%20warm%20pink%20tones%2C%20clean%20anime%20art%20style%2C%20gentle%20expression%2C%20spring%20atmosphere%2C%20delicate%20lineart%2C%20manga%20cover%20design%2C%20light%20cream%20background%20with%20scattered%20peach%20petals&width=400&height=560&seq=comic-cover-01&orientation=portrait',
    description: '平凡少年林逸偶然获得神秘蜜桃印记，从此踏上了一段奇妙的冒险之旅。在这个充满神秘力量的世界里，他结识了志同道合的朋友，共同面对重重挑战。',
    status: '连载中',
    rating: 9.2,
    views: 1258000,
    chapters: [
      { num: 1, title: '神秘的印记', updatedAt: '2026-08-01' },
      { num: 2, title: '觉醒之力', updatedAt: '2026-07-28' },
      { num: 3, title: '初遇同伴', updatedAt: '2026-07-25' },
      { num: 4, title: '第一个考验', updatedAt: '2026-07-22' },
      { num: 5, title: '蜜桃的力量', updatedAt: '2026-07-19' },
      { num: 6, title: '暗影逼近', updatedAt: '2026-07-16' },
      { num: 7, title: '守护之战', updatedAt: '2026-07-13' },
      { num: 8, title: '新的伙伴', updatedAt: '2026-07-10' },
      { num: 9, title: '谜团重重', updatedAt: '2026-07-07' },
      { num: 10, title: '决战前夕', updatedAt: '2026-07-04' },
      { num: 11, title: '觉醒时刻', updatedAt: '2026-07-01' },
      { num: 12, title: '蜜桃绽放', updatedAt: '2026-06-28' },
    ],
  },
  {
    id: 2,
    slug: 'xingkong-qiyuan',
    title: '星空奇缘',
    author: '星尘漫画',
    category: 'lianai',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20romance%20manga%20illustration%20of%20a%20couple%20under%20starry%20night%20sky%2C%20soft%20blue%20and%20pink%20color%20palette%2C%20dreamy%20atmosphere%2C%20anime%20art%20style%2C%20starlight%20reflection%2C%20gentle%20embrace%2C%20clean%20manga%20cover%20design%2C%20light%20cream%20background&width=400&height=560&seq=comic-cover-02&orientation=portrait',
    description: '天文社少女苏星在观测星空时，意外与来自遥远星系的少年相遇。跨越星际的爱恋，在璀璨星空中悄然绽放。一场浪漫的星空之旅就此展开。',
    status: '连载中',
    rating: 9.5,
    views: 2156000,
    chapters: [
      { num: 1, title: '星之邂逅', updatedAt: '2026-08-03' },
      { num: 2, title: '遥远来客', updatedAt: '2026-07-31' },
      { num: 3, title: '星语心愿', updatedAt: '2026-07-28' },
      { num: 4, title: '月下之约', updatedAt: '2026-07-25' },
      { num: 5, title: '星空漫步', updatedAt: '2026-07-22' },
      { num: 6, title: '心之距离', updatedAt: '2026-07-19' },
    ],
  },
  {
    id: 3,
    slug: 'liehuo-shenjue',
    title: '烈火神诀',
    author: '炎龙社',
    category: 'rexue',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20action%20manga%20illustration%20of%20a%20warrior%20wielding%20flames%2C%20dynamic%20fire%20effects%2C%20intense%20battle%20pose%2C%20warm%20orange%20and%20red%20tones%2C%20anime%20art%20style%2C%20martial%20arts%20theme%2C%20clean%20manga%20cover%20design%2C%20light%20cream%20background&width=400&height=560&seq=comic-cover-03&orientation=portrait',
    description: '在武道为尊的世界里，少年楚炎意外获得上古烈火神诀，从此逆天改命。以火焰之力横扫天下，谱写了一段热血传奇。',
    status: '连载中',
    rating: 9.0,
    views: 1893000,
    chapters: [
      { num: 1, title: '废柴少年', updatedAt: '2026-08-02' },
      { num: 2, title: '烈火传承', updatedAt: '2026-07-30' },
      { num: 3, title: '初露锋芒', updatedAt: '2026-07-27' },
      { num: 4, title: '宗门大比', updatedAt: '2026-07-24' },
      { num: 5, title: '烈焰滔天', updatedAt: '2026-07-21' },
    ],
  },
  {
    id: 4,
    slug: 'xiaoyuan-xiaohua',
    title: '校园笑话王',
    author: '哈哈漫画',
    category: 'gaoxiao',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20comedy%20school%20life%20manga%20illustration%20with%20funny%20expressions%2C%20colorful%20bright%20atmosphere%2C%20chibi%20style%20characters%2C%20humorous%20scene%2C%20anime%20art%20style%2C%20lighthearted%20mood%2C%20clean%20manga%20cover%20design%2C%20light%20cream%20background&width=400&height=560&seq=comic-cover-04&orientation=portrait',
    description: '转学生李大宝凭借超强幽默感，迅速成为校园红人。每天都有笑料百出的校园趣事，让你笑到停不下来！轻松欢乐的校园日常喜剧。',
    status: '已完结',
    rating: 8.8,
    views: 3456000,
    chapters: [
      { num: 1, title: '新来的转学生', updatedAt: '2026-06-15' },
      { num: 2, title: '食堂大作战', updatedAt: '2026-06-10' },
      { num: 3, title: '考试风波', updatedAt: '2026-06-05' },
      { num: 4, title: '运动会趣事', updatedAt: '2026-05-30' },
      { num: 5, title: '毕业快乐', updatedAt: '2026-05-25' },
    ],
  },
  {
    id: 5,
    slug: 'jiuchong-tiangong',
    title: '九重天宫',
    author: '幻境工坊',
    category: 'xuanhuan',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20fantasy%20xianxia%20manga%20illustration%20of%20a%20cultivator%20in%20flowing%20robes%20amid%20celestial%20palaces%2C%20ethereal%20golden%20light%2C%20floating%20mountains%2C%20mystical%20atmosphere%2C%20anime%20art%20style%2C%20grand%20scale%2C%20clean%20manga%20cover%2C%20light%20cream%20background&width=400&height=560&seq=comic-cover-05&orientation=portrait',
    description: '修仙少年叶尘误入九重天宫遗迹，获得远古传承。从此踏上攀登九重天的修仙之路，历经磨难，终成一代仙尊。',
    status: '连载中',
    rating: 9.3,
    views: 2789000,
    chapters: [
      { num: 1, title: '天宫遗迹', updatedAt: '2026-08-04' },
      { num: 2, title: '远古传承', updatedAt: '2026-08-01' },
      { num: 3, title: '踏入仙途', updatedAt: '2026-07-29' },
      { num: 4, title: '金丹大道', updatedAt: '2026-07-26' },
    ],
  },
  {
    id: 6,
    slug: 'anye-zhuizong',
    title: '暗夜追踪',
    author: '暗影漫画',
    category: 'xuanyi',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20mystery%20thriller%20manga%20illustration%20of%20a%20detective%20in%20dark%20alley%2C%20noir%20atmosphere%2C%20moonlight%20shadows%2C%20suspenseful%20mood%2C%20anime%20art%20style%2C%20dramatic%20lighting%2C%20clean%20manga%20cover%2C%20light%20cream%20background&width=400&height=560&seq=comic-cover-06&orientation=portrait',
    description: '天才侦探沈夜接手了一系列离奇案件，每个案件背后都隐藏着不为人知的秘密。随着调查深入，一个巨大的阴谋逐渐浮出水面。',
    status: '连载中',
    rating: 9.1,
    views: 1567000,
    chapters: [
      { num: 1, title: '血色玫瑰', updatedAt: '2026-08-03' },
      { num: 2, title: '失踪者', updatedAt: '2026-07-31' },
      { num: 3, title: '午夜来电', updatedAt: '2026-07-28' },
    ],
  },
  {
    id: 7,
    slug: 'jixie-jiyuan',
    title: '机械纪元',
    author: '未来漫画',
    category: 'kehuan',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20sci%20fi%20manga%20illustration%20of%20a%20cyborg%20character%20in%20futuristic%20cityscape%2C%20neon%20lights%2C%20cyberpunk%20atmosphere%2C%20mechanical%20details%2C%20anime%20art%20style%2C%20cool%20silver%20and%20blue%20tones%2C%20clean%20manga%20cover%2C%20light%20cream%20background&width=400&height=560&seq=comic-cover-07&orientation=portrait',
    description: '公元2150年，人类与机器人的共存时代。少年机械师零号在废铁堆中发现了一个拥有自我意识的机器人少女，从此命运之轮开始转动。',
    status: '连载中',
    rating: 8.9,
    views: 1023000,
    chapters: [
      { num: 1, title: '废铁堆的少女', updatedAt: '2026-08-05' },
      { num: 2, title: '觉醒', updatedAt: '2026-08-02' },
    ],
  },
  {
    id: 8,
    slug: 'yingxiong-wudi',
    title: '英雄无敌',
    author: '战神漫画',
    category: 'dongzuo',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20hero%20action%20manga%20illustration%20of%20a%20superhero%20in%20dynamic%20flying%20pose%2C%20city%20background%2C%20dramatic%20wind%20effects%2C%20bold%20composition%2C%20anime%20art%20style%2C%20vibrant%20colors%2C%20clean%20manga%20cover%2C%20light%20cream%20background&width=400&height=560&seq=comic-cover-08&orientation=portrait',
    description: '普通高中生赵英雄意外获得超能力，化身城市守护者。面对不断出现的超级反派，他能否守护这座城市？充满激情的超级英雄故事。',
    status: '已完结',
    rating: 8.7,
    views: 2345000,
    chapters: [
      { num: 1, title: '意外觉醒', updatedAt: '2026-05-20' },
      { num: 2, title: '初战', updatedAt: '2026-05-15' },
      { num: 3, title: '英雄之名', updatedAt: '2026-05-10' },
      { num: 4, title: '最终决战', updatedAt: '2026-05-05' },
    ],
  },
  {
    id: 9,
    slug: 'hua-yang-nianhua',
    title: '花样年华',
    author: '花语社',
    category: 'lianai',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20youth%20romance%20manga%20illustration%20of%20high%20school%20students%20under%20cherry%20blossoms%2C%20spring%20atmosphere%2C%20soft%20pastel%20pink%20tones%2C%20gentle%20breeze%2C%20anime%20art%20style%2C%20nostalgic%20mood%2C%20clean%20manga%20cover%2C%20light%20cream%20background&width=400&height=560&seq=comic-cover-09&orientation=portrait',
    description: '高中三年，是最美的花样年华。少女林花与少年杨华，在樱花纷飞的校园里，谱写了一段青涩而美好的青春恋歌。',
    status: '已完结',
    rating: 9.4,
    views: 4123000,
    chapters: [
      { num: 1, title: '樱花下的相遇', updatedAt: '2026-04-20' },
      { num: 2, title: '同桌的你', updatedAt: '2026-04-15' },
      { num: 3, title: '心动瞬间', updatedAt: '2026-04-10' },
      { num: 4, title: '毕业季', updatedAt: '2026-04-05' },
      { num: 5, title: '再会', updatedAt: '2026-03-30' },
    ],
  },
  {
    id: 10,
    slug: 'reshen-jianglin',
    title: '刃神降临',
    author: '刀锋漫画',
    category: 'rexue',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20sword%20fighting%20manga%20illustration%20of%20a%20swordsman%20with%20flowing%20hair%2C%20sharp%20blade%20gleaming%2C%20dramatic%20wind%20and%20light%20effects%2C%20epic%20atmosphere%2C%20anime%20art%20style%2C%20cool%20color%20tones%2C%20clean%20manga%20cover%2C%20light%20cream%20background&width=400&height=560&seq=comic-cover-10&orientation=portrait',
    description: '剑道天才慕容刃为寻找失踪的师父，踏上了一条充满危险的旅途。刀光剑影中，他将揭开一个惊天的秘密。刃之极致，即为神！',
    status: '连载中',
    rating: 9.1,
    views: 1678000,
    chapters: [
      { num: 1, title: '刀出鞘', updatedAt: '2026-08-04' },
      { num: 2, title: '剑指天涯', updatedAt: '2026-08-01' },
      { num: 3, title: '秘境探险', updatedAt: '2026-07-29' },
      { num: 4, title: '刃之道', updatedAt: '2026-07-26' },
    ],
  },
  {
    id: 11,
    slug: 'xiaoao-xiaoyuan',
    title: '笑傲校园',
    author: '开心漫画',
    category: 'gaoxiao',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20comedy%20slice%20of%20life%20manga%20illustration%20with%20exaggerated%20funny%20faces%2C%20classroom%20setting%2C%20bright%20cheerful%20colors%2C%20comic%20expressions%2C%20anime%20art%20style%2C%20humorous%20chaos%2C%20clean%20manga%20cover%2C%20light%20cream%20background&width=400&height=560&seq=comic-cover-11&orientation=portrait',
    description: '一群性格迥异的高中生，在校园里上演了一幕幕令人捧腹的喜剧。没有烦恼，只有欢笑！解压必备的爆笑校园喜剧漫画。',
    status: '连载中',
    rating: 8.6,
    views: 2891000,
    chapters: [
      { num: 1, title: '开学第一天', updatedAt: '2026-08-05' },
      { num: 2, title: '班主任是魔鬼', updatedAt: '2026-08-02' },
      { num: 3, title: '逃课大作战', updatedAt: '2026-07-30' },
    ],
  },
  {
    id: 12,
    slug: 'tianming-zhiren',
    title: '天命之人',
    author: '天命漫画',
    category: 'xuanhuan',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20xianxia%20cultivation%20manga%20illustration%20of%20a%20young%20immortal%20with%20glowing%20aura%2C%20floating%20in%20clouds%2C%20mystical%20symbols%2C%20golden%20energy%2C%20ethereal%20atmosphere%2C%20anime%20art%20style%2C%20epic%20scale%2C%20clean%20manga%20cover%2C%20light%20cream%20background&width=400&height=560&seq=comic-cover-12&orientation=portrait',
    description: '生来便背负天命印记的少年云逸，注定要成为拯救苍生的天命之人。在修行路上，他不断成长，与命运抗争，谱写一段不朽传奇。',
    status: '连载中',
    rating: 9.0,
    views: 1987000,
    chapters: [
      { num: 1, title: '天命印记', updatedAt: '2026-08-03' },
      { num: 2, title: '觉醒之路', updatedAt: '2026-07-31' },
      { num: 3, title: '命运之战', updatedAt: '2026-07-28' },
    ],
  },
];

export const testimonials = [
  {
    id: 1,
    name: '小明同学',
    avatar: 'https://readdy.ai/api/search-image?query=Chinese%20anime%20style%20boy%20avatar%20portrait%2C%20simple%20clean%20illustration%2C%20soft%20warm%20colors%2C%20friendly%20smile&width=80&height=80&seq=avatar-01&orientation=squarish',
    content: '蜜桃少年漫画真的太棒了！画质清晰，更新速度超快，而且完全免费。每天放学回家第一件事就是打开看更新，已经成为我的日常习惯了！',
    rating: 5,
  },
  {
    id: 2,
    name: '漫画迷小玲',
    avatar: 'https://readdy.ai/api/search-image?query=Chinese%20anime%20style%20girl%20avatar%20portrait%2C%20simple%20clean%20illustration%2C%20soft%20pink%20tones%2C%20gentle%20smile&width=80&height=80&seq=avatar-02&orientation=squarish',
    content: '下拉式阅读体验太流畅了！看漫画不用一页页翻，直接往下滑就行，沉浸感超强。漫画种类也很丰富，什么类型的都能找到。',
    rating: 5,
  },
  {
    id: 3,
    name: '热血少年阿杰',
    avatar: 'https://readdy.ai/api/search-image?query=Chinese%20anime%20style%20teenage%20boy%20avatar%20portrait%2C%20simple%20clean%20illustration%2C%20energetic%20expression%2C%20warm%20orange%20tones&width=80&height=80&seq=avatar-03&orientation=squarish',
    content: '推荐给所有喜欢看漫画的朋友！蜜桃少年漫画上面的热血漫真的燃到爆炸，剧情紧凑不拖沓，每周都盼着更新。强烈推荐！',
    rating: 5,
  },
  {
    id: 4,
    name: '甜甜的棉花糖',
    avatar: 'https://readdy.ai/api/search-image?query=Chinese%20anime%20style%20cute%20girl%20avatar%20portrait%2C%20simple%20clean%20illustration%2C%20sweet%20expression%2C%20soft%20pastel%20colors&width=80&height=80&seq=avatar-04&orientation=squarish',
    content: '恋爱漫画太好看了！《星空奇缘》和《花样年华》都追完了，每一部都让人少女心爆棚。感谢蜜桃少年漫画提供了这么好的平台！',
    rating: 4,
  },
];

export const faqs = [
  {
    q: '蜜桃少年漫画是免费的吗？',
    a: '是的，蜜桃少年漫画完全免费！我们提供漫画全集免费阅读下拉式服务，所有漫画都可以免费在线阅读，无需付费订阅。我们致力于为广大漫画爱好者提供最优质的免费阅读体验。',
  },
  {
    q: '如何在线浏览漫画？',
    a: '蜜桃少年漫画采用下拉式阅读模式，您只需打开想看的漫画，向下滑动即可流畅阅读。无需翻页操作，让阅读体验更加沉浸和自然。支持手机和电脑端浏览。',
  },
  {
    q: '漫画更新频率是怎样的？',
    a: '我们的漫画保持稳定的更新频率，大部分热门漫画每周更新1-2话。您可以在首页"最近更新"板块查看最新更新的漫画章节。我们与土豪漫画网合作，确保内容的及时更新。',
  },
  {
    q: '支持哪些设备阅读？',
    a: '蜜桃少年漫画支持所有主流设备，包括电脑、平板和手机。网站采用响应式设计，会根据您的设备自动调整布局，在任何屏幕上都能获得舒适的阅读体验。',
  },
  {
    q: '如何找到想看的漫画？',
    a: '您可以通过首页的分类导航浏览不同类型的漫画，也可以在排行榜中查看热门作品。我们提供了少年漫画、恋爱漫画、热血漫画、搞笑漫画等多个分类，方便您快速找到感兴趣的作品。',
  },
];